const AddressStepSkeleton = () => {
  return <>
      <div className="border-lightgray animate-pulse rounded-lg border-2 md:min-h-[437px]">
        <div className="mb-4 flex justify-between p-4">
          <div className="h-6 w-1/4 rounded bg-gray-300"></div>
          <div className="h-6 w-20 rounded bg-gray-300"></div>
        </div>
        <div className="mb-4 grid grid-cols-2 gap-8 px-4">
          <div>
            <div className="mb-2 flex space-x-4">
              <div className="size-3 rounded-full bg-gray-300"></div>
              <div className="h-3 w-full rounded bg-gray-200"></div>
            </div>
            {[...Array(6)].map((_, i) => <div key={i} className="flex items-center space-x-4 py-1">
                <div className="h-3 w-full rounded bg-gray-200"></div>
              </div>)}
          </div>
          <div>
            <div className="mb-2 flex space-x-4">
              <div className="size-3 rounded-full bg-gray-300"></div>
              <div className="h-3 w-full rounded bg-gray-200"></div>
            </div>
            {[...Array(6)].map((_, i) => <div key={i} className="flex items-center space-x-4 py-1">
                <div className="h-3 w-full rounded bg-gray-200"></div>
              </div>)}
          </div>
        </div>
      </div>
      <div className="animate-pulse py-4">
        <div className="flex h-12 w-full items-center justify-center rounded-lg bg-gray-300">
          <span className="h-6 w-1/4 rounded bg-gray-200"></span>
        </div>
      </div>
    </>;
};
export default AddressStepSkeleton;